import * as React from 'react';

interface IProps {
    input: {
        value: string;
    };
}

export class RenderReadOnly extends React.PureComponent<IProps> {
    render() {
        const {
            input: { value }
        } = this.props;
        return <div>{value}</div>;
    }
}

export default RenderReadOnly;
